import Star from '@material-ui/icons/Star';
import React from 'react';
import { ProviderSettingsItem } from './ProviderSettingsItem.esm.js';
import { googleAuthApiRef, microsoftAuthApiRef, githubAuthApiRef, gitlabAuthApiRef, oktaAuthApiRef, bitbucketAuthApiRef, oneloginAuthApiRef, atlassianAuthApiRef, bitbucketServerAuthApiRef } from '@backstage/core-plugin-api';

const DefaultProviderSettings = (props) => {
  const { configuredProviders } = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, configuredProviders.includes("google") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "Google",
      description: "Provides authentication towards Google APIs and identities",
      apiRef: googleAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("microsoft") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "Microsoft",
      description: "Provides authentication towards Microsoft APIs and identities",
      apiRef: microsoftAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("github") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "GitHub",
      description: "Provides authentication towards GitHub APIs",
      apiRef: githubAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("gitlab") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "GitLab",
      description: "Provides authentication towards GitLab APIs",
      apiRef: gitlabAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("okta") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "Okta",
      description: "Provides authentication towards Okta APIs",
      apiRef: oktaAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("bitbucket") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "Bitbucket",
      description: "Provides authentication towards Bitbucket APIs",
      apiRef: bitbucketAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("onelogin") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "OneLogin",
      description: "Provides authentication towards OneLogin APIs",
      apiRef: oneloginAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("atlassian") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "Atlassian",
      description: "Provides authentication towards Atlassian APIs",
      apiRef: atlassianAuthApiRef,
      icon: Star
    }
  ), configuredProviders.includes("bitbucketServer") && /* @__PURE__ */ React.createElement(
    ProviderSettingsItem,
    {
      title: "Bitbucket Server",
      description: "Provides authentication towards Bitbucket Server APIs",
      apiRef: bitbucketServerAuthApiRef,
      icon: Star
    }
  ));
};

export { DefaultProviderSettings };
//# sourceMappingURL=DefaultProviderSettings.esm.js.map
